import { createEmptyLevel, type DungeonLevel, type DungeonTile } from '@dungeon-builder/shared';

/**
 * A hand-made room-and-corridor level used until real player-authored levels can
 * be loaded from the editor. Purely a placeholder for the render path.
 */
export function createSampleLevel(): DungeonLevel {
  const width = 13;
  const height = 11;
  const tiles: DungeonTile[] = [];

  for (let z = 0; z < height; z++) {
    for (let x = 0; x < width; x++) {
      const isBorder = x === 0 || z === 0 || x === width - 1 || z === height - 1;
      tiles.push({ x, z, kind: isBorder ? 'wall' : 'floor', rotation: 0 });
    }
  }

  const replace = (x: number, z: number, kind: DungeonTile['kind']) => {
    const tile = tiles.find((candidate) => candidate.x === x && candidate.z === z);
    if (tile) tile.kind = kind;
  };

  // An inner wall with a doorway, to make the placeholder read as a dungeon.
  for (let z = 3; z <= 7; z++) replace(6, z, 'wall');
  replace(6, 5, 'door');

  replace(2, 5, 'spawn');
  replace(10, 5, 'exit');
  replace(9, 2, 'chest');
  replace(4, 8, 'trap');

  return createEmptyLevel({ name: 'Placeholder Crypt', width, height, tiles });
}
